import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'osp-input-help-text',
  templateUrl: './input-help-text.component.html',
  styleUrl: './input-help-text.component.scss',
  standalone: true, 
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputHelpTextComponent{
  @Input() helpText: string = '';
}